var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.437,
    height: 33.853,
    viewBox: "0 0 23.437 33.853",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#5aa3d5;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.211,4a3.385,3.385,0,1,0,3.346,3.383A3.364,3.364,0,0,0,24.211,4ZM21.7,12.462a3.274,3.274,0,0,0-1.623.443c-.107.043-.215.072-.32.124l-.016.008-5.715,2.948a1.257,1.257,0,0,0-.41.337l-3.344,4.231a1.28,1.28,0,0,0,.2,1.785,1.245,1.245,0,0,0,1.764-.2l3.147-3.981,2.41-.656-1.014,5.213c-.01.047-.019.093-.028.14l-.024.129.011,0a3.212,3.212,0,0,0,1.272,3.152l0,0,.113.086c.021.015.041.032.062.046l5.2,3.955,3.486,6.958,0-.017a1.247,1.247,0,0,0,1.626.567,1.275,1.275,0,0,0,.657-1.609l-2.508-6.77a1.273,1.273,0,0,0-.2-.355l0,0L23.28,24.669l1.154-5.978,1.4,2.086.242.395a1.26,1.26,0,0,0,.5.464L31.6,24.175a1.241,1.241,0,0,0,1.27-.058,1.277,1.277,0,0,0-.15-2.213l-4.7-2.378L24.866,14.4l0,0a3.6,3.6,0,0,0-.723-.854A3.307,3.307,0,0,0,21.7,12.462ZM17.075,27.616l-.751,3.633-3.393,4.376-.056.056a1.28,1.28,0,0,0,0,1.8,1.244,1.244,0,0,0,1.774,0l4.18-4.231a1.274,1.274,0,0,0,.359-.7l1.1-2.527Z",
    transform: "translate(-9.999 -4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalking);
export default __webpack_public_path__ + "static/media/walking.42339b80e5e4d1a2372a2064b53b92be.svg";
export { ForwardRef as ReactComponent };